import React from 'react';
import { useSelector } from 'react-redux';
import { Card, Flex, Text } from '@radix-ui/themes';
import { RootState } from '../../redux/store';
import { formatDate, formatDateForOutput } from '../../utils/dateFormatter';

export const UserPreview = () => {
  const userData = useSelector((state: RootState) => state.user);

  return (
    <Flex direction='column' gap='4'  wrap="wrap">
      <Card size='3' style={{overflow:"scroll"}}>
        <Flex direction='column' gap='4'>
          <Flex gap="8">
            <Flex direction="column" style={{ width: '100%' }}>
              <Text size="2">Nome</Text>
              <Text size="3" weight="medium">{userData?.name || 'N/A'}</Text>
            </Flex>
            <Flex direction="column" style={{ width: '100%' }}>
              <Text size="2">Utilizador</Text>
              <Text size="3" weight="medium">{userData?.userName || 'N/A'}</Text>
            </Flex>
            <Flex direction="column" style={{ width: '100%' }}>
              <Text size="2">Email</Text>
              <Text size="3" weight="medium">{userData?.email || 'N/A'}</Text>
            </Flex>
          </Flex>

          <Flex gap="8">
            <Flex direction="column" style={{ width: '100%' }}>
              <Text size="2">Documento de identificação</Text>
              <Text size="3" weight="medium">{userData?.bi || 'N/A'}</Text>
            </Flex>
            <Flex direction="column" style={{ width: '100%' }}>
              <Text size="2">NUIT</Text>
              <Text size="3" weight="medium">{userData?.nuit || 'N/A'}</Text>
            </Flex>
            <Flex direction="column" style={{ width: '100%' }}>
              <Text size="2">Telefone</Text>
              <Text size="3" weight="medium">{userData?.phoneNumber || 'N/A'}</Text>
            </Flex>
          </Flex>

          <Flex gap="8">
            <Flex direction="column" style={{ width: '32%' }}>
              <Text size="2">Data de Nascimento</Text>
              <Text size="3" weight="medium">
                {userData?.dateOfBirth ? formatDateForOutput(userData.dateOfBirth) : 'N/A'}
              </Text>
            </Flex>
            <Flex direction="column" style={{ width: '68%' }}>
              <Text size="2">Gênero</Text>
              <Text size="3" weight="medium">
                {userData?.gender === 'M' ? 'Masculino' : 'Feminino'}
              </Text>
            </Flex>
          </Flex>
        </Flex>
      </Card>
    </Flex>
  );
};

